import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { SYNMATCH_COLORS, SYNMATCH_RADII } from 'theme';

export const JobsList = styled.ul`
  margin: 1.75rem 0 0;
  padding: 0;
  list-style: none;
  border-top: 0.0625rem solid ${SYNMATCH_COLORS.border.default};
`;

export const JobsListItem = styled.li`
  margin: 0;
`;

export const JobRowLink = styled(Link)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.5rem 0.25rem;
  border-bottom: 0.0625rem solid ${SYNMATCH_COLORS.border.default};
  text-decoration: none;
  color: inherit;
  border-radius: ${SYNMATCH_RADII.sm};
  transition: padding-left 150ms ease, background 150ms ease, color 150ms ease;

  &::before {
    content: '';
    position: absolute;
    left: -0.6rem;
    top: 50%;
    width: 0.125rem;
    height: 60%;
    background: ${SYNMATCH_COLORS.primary};
    opacity: 0;
    transform: translateY(-50%) scaleY(0.2);
    transform-origin: center;
    transition: opacity 150ms ease, transform 150ms ease;
  }

  &:hover,
  &:focus-visible {
    padding-left: 1.1rem;
    background: linear-gradient(
      90deg,
      ${SYNMATCH_COLORS.surface.app},
      transparent 70%
    );
    outline: none;
  }

  &:hover::before,
  &:focus-visible::before {
    opacity: 1;
    transform: translateY(-50%) scaleY(1);
  }

  &:hover .job-row-title,
  &:focus-visible .job-row-title {
    color: ${SYNMATCH_COLORS.primary};
  }

  &:hover .job-row-arrow,
  &:focus-visible .job-row-arrow {
    transform: translateX(0.25rem);
    color: ${SYNMATCH_COLORS.primary};
  }

  &:focus-visible {
    outline: 0.125rem solid ${SYNMATCH_COLORS.primary};
    outline-offset: 0.25rem;
  }

  @media (max-width: 30rem) {
    padding: 1.25rem 0.25rem;
    gap: 1rem;

    &:hover,
    &:focus-visible {
      padding-left: 0.6rem;
    }
  }
`;

export const JobRowMain = styled.div`
  min-width: 0;
`;

export const JobRowTitle = styled.h3.attrs({ className: 'job-row-title' })`
  margin: 0 0 0.375rem;
  font-size: clamp(1.2rem, 2vw, 1.5rem);
  font-weight: 540;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: ${SYNMATCH_COLORS.primary};
  overflow-wrap: anywhere;
  transition: color 150ms ease;
`;

export const JobRowMeta = styled.p`
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem 0.85rem;
  font-size: 0.9rem;
  letter-spacing: -0.008em;
  color: ${SYNMATCH_COLORS.text.muted};
`;

export const JobRowMetaSeparator = styled.span`
  width: 0.1875rem;
  height: 0.1875rem;
  border-radius: 50%;
  background: ${SYNMATCH_COLORS.border.default};
  flex-shrink: 0;
`;

export const JobRowComp = styled.span`
  color: ${SYNMATCH_COLORS.text.default};
  font-weight: 480;
`;

export const JobRowArrow = styled.span.attrs({ className: 'job-row-arrow' })`
  display: inline-flex;
  flex-shrink: 0;
  color: ${SYNMATCH_COLORS.text.muted};
  transition: transform 150ms ease, color 150ms ease;

  .MuiSvgIcon-root {
    font-size: 1.375rem;
  }
`;

export const SkeletonList = styled.div`
  margin-top: 2.5rem;
  border-top: 0.0625rem solid ${SYNMATCH_COLORS.border.default};
`;

export const SkeletonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.5rem 0;
  border-bottom: 0.0625rem solid ${SYNMATCH_COLORS.border.default};
`;
